import React, { useState, useEffect, useCallback } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import Comments from '../components/Comments';
import '../css.css';

const HEADERS = [
  { key: 'name', label: '이름' },
  { key: 'progress', label: '해금 단계' },
  { key: 'point', label: '요구 포인트' },
  { key: 'evaluation', label: '설명' },
  { key: 'note', label: '비고' },
];

const SkillPage = () => {
    const [skillData, setSkillData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedType, setSelectedType] = useState('');

    const fetchSkillData = useCallback(async () => {
        setLoading(true);
        setError(null);
        
        try {
            const response = await fetch('/api/skill');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            setSkillData(data);
            
            // 데이터를 불러온 후 첫 번째 타입을 기본 선택값으로 설정
            if (data.length > 0) {
                const firstType = data[0].type;
                setSelectedType(firstType);
            }
        } catch (error) {
            console.error('Error fetching skill data:', error);
            setError('스킬 정보를 불러오는데 실패했습니다.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSkillData();
    }, [fetchSkillData]);

    // 타입별 라벨 매핑
    const typeLabels = {
        telescopic: '찌 낚시',
        spin: '스핀 낚시',
        bottom: '바텀 낚시',
        marine: '해양 낚시',
        bait: '미끼 채집',
        cooking: '요리',
        groundbait: '밑밥 만들기',
        make_lure: '루어 만들기'
    };

    // 고유한 타입들 가져오기
    const uniqueTypes = [...new Set(skillData.map(skill => skill.type))];

    // 필터링된 데이터 (전체 옵션 제거)
    const filteredData = skillData.filter(skill => skill.type === selectedType);

    // 설명 텍스트에서 \n을 <br>로 변환
    const formatDescription = (text) => {
        if (!text) return '';
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                {index < text.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    };

    if (loading) {
        return (
            <>
                <h1 className="page-title">스킬 정리</h1>
                <div className="spinner-container">
                    <LoadingSpinner
                        height={80}
                        width={80}
                        color="#4fa94d"
                        visible={true}
                    />
                </div>
                <Comments pageName="skill" />
            </>
        );
    }

    if (error) {
        return (
            <>
                <h1 className="page-title">스킬 정리</h1>
                <div className="error-message">
                    <p>{error}</p>
                    <button onClick={fetchSkillData}>다시 시도</button>
                </div>
                <Comments pageName="skill" />
            </>
        );
    }

    return (
        <>
            <h1 className="page-title">스킬 정리</h1>
            <div className="skill-container">
                <div className="skill-filter-buttons">
                    {uniqueTypes.map(type => (
                        <button 
                            key={type}
                            className={selectedType === type ? 'active' : ''}
                            onClick={() => setSelectedType(type)}
                        >
                            {typeLabels[type] || type}
                        </button>
                    ))}
                </div>

                <div className="page-content">
                    <table className="oil-table" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                {HEADERS.map((header) => (
                                    <th key={header.key}>{header.label}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((skill, idx) => (
                                <tr key={skill.id || idx}>
                                    {HEADERS.map((header) => (
                                        <td key={header.key}>
                                            {header.key === 'evaluation' 
                                                ? formatDescription(skill[header.key]) 
                                                : (skill[header.key] || '')
                                            }
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {filteredData.length === 0 && (
                    <div className="no-data-message">
                        선택한 타입에 대한 스킬 정보가 없습니다.
                    </div>
                )}
            </div>
            <Comments pageName="skill" />
        </>
    );
};

export default SkillPage;